export class AuditRelation {
   public id: number;
   public alarmId: number;
   public auditId: number;
   public userId: number;
   public datetime: Date;
}

